import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'ag-patron-expiry-msg-dialog',
  templateUrl: './patron-expiry-msg-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PatronExpiryMsgDialog {
  name: string;
  expireDate: string;
  expireText: string;

  constructor(@Inject(MAT_DIALOG_DATA) private _userData: any) {
    if (_userData) {
      this.name = `${_userData.firstName} ${_userData.lastName}`;
      this.expireDate = _userData.expireDate;
      this.expireText = new Date(_userData.expireDate) < new Date() ? 'expired' : 'will expire';
    }
  }
}
